"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var translations = {
    maxSpeed: {
        en: "Max speed",
        es: "Velocidad Maxima",
    },
    filling: {
        en: "Filling",
        es: "Llenado",
    },
    consumption: {
        en: "Consumption",
        es: "Consumo",
    },
    efficiency: {
        en: "Efficiency",
        es: "Eficiencia",
    },
    fetch: {
        en: "Fetch",
        es: "Obtener",
    },
    summary: {
        en: "Summary",
        es: "Resumen",
    },
    tank: {
        en: "Tank",
        es: "Tanque",
    },
    verifyEmail: {
        en: "Verify email",
        es: "Verificar correo",
    },
    name: {
        en: "Name",
        es: "Nombre",
    },
    namePlaceholder: {
        en: "Name",
        es: "Nombre",
    },
    email: {
        en: "Email",
        es: "Correo",
    },
    emailPlaceholder: {
        en: "Email",
        es: "Correo",
    },
    oldPassword: {
        en: "Old Password",
        es: "Contraseña Actual",
    },
    oldPasswordPlaceholder: {
        en: "Old Password",
        es: "Contraseña Actual",
    },
    newPassword: {
        en: "New Password",
        es: "Contraseña Nueva",
    },
    newPasswordPlaceholder: {
        en: "New Password",
        es: "Contraseña Nueva",
    },
    password: {
        en: "Password",
        es: "Contraseña",
    },
    passwordPlaceholder: {
        en: "Password",
        es: "Contraseña",
    },
    passwordConfirm: {
        en: "Confirm Password",
        es: "Confirmar Contraseña",
    },
    profilePassword: {
        en: "Change Password",
        es: "Cambiar Contraseña",
    },
    currentPasswordWrong: {
        en: "The old password you entered was incorrect, please write the correct password.",
        es: "La contraseña actual es incorrecta, por favor ingrese la contraseña correcta.",
    },
    passwordChanged: {
        en: "The password was changed correctly.",
        es: "La contraseña se cambio correctamente.",
    },
    passwordConfirmPlaceholder: {
        en: "Confirm Password",
        es: "Confirmar Contraseña",
    },
    unitSystem: {
        en: "Measuring system",
        es: "Sistema de medición",
    },
    unitSystemPlaceholder: {
        en: "Select Unit System",
        es: "Seleccione Sistema métrico",
    },
    languages: {
        en: "Language",
        es: "Idioma",
    },
    languagesPlaceholder: {
        en: "Select Language",
        es: "Elije un Idioma",
    },
    active: {
        en: "Active",
        es: "Activo",
    },
    inactive: {
        en: "Inactive",
        es: "Inactivo",
    },
    actions: {
        en: "Actions",
        es: "Acciones",
    },
    username: {
        en: "Username",
        es: "Usuario",
    },
    usernamePlaceholder: {
        en: "Username",
        es: "Usuario",
    },
    company: {
        en: "Provider",
        es: "Proveedor",
    },
    companyPlaceholder: {
        en: "Provider",
        es: "Proveedor",
    },
    client: {
        en: "Client",
        es: "Cliente",
    },
    clientPlaceholder: {
        en: "Client",
        es: "Cliente",
    },
    pin: {
        en: "ID",
        es: "ID",
    },
    pinPlaceholder: {
        en: "ID",
        es: "ID",
    },
    description: {
        en: "Description",
        es: "Descripción",
    },
    descriptionPlaceholder: {
        en: "Description",
        es: "Descripción",
    },
    imei: {
        en: "Imei",
        es: "Imei",
    },
    imeiPlaceholder: {
        en: "Imei",
        es: "Imei",
    },
    dataPort: {
        en: "Data Port",
        es: "Puerto",
    },
    dataPortPlaceholder: {
        en: "Data Port",
        es: "Puerto",
    },
    firmwareVersion: {
        en: "Firmware",
        es: "Firmware",
    },
    firmwareVersionPlaceholder: {
        en: "Firmware",
        es: "Firmware",
    },
    icon: {
        en: "Icon",
        es: "Icono",
    },
    iconPlaceholder: {
        en: "Icon",
        es: "Icono",
    },
    deviceModel: {
        en: "Model",
        es: "Modelo",
    },
    deviceModelPlaceholder: {
        en: "Device Model",
        es: "Modelo de la unidad",
    },
    modelProfilePlaceholder: {
        en: "Model profile",
        es: "Perfil de la unidad",
    },
    deviceStatus: {
        en: "Status",
        es: "Estatus",
    },
    deviceStatusPlaceholder: {
        en: "Device Status",
        es: "Estatus de la unidad",
    },
    sim: {
        en: "Sim",
        es: "Sim",
    },
    simPlaceholder: {
        en: "Sim",
        es: "Sim",
    },
    line: {
        en: "Line",
        es: "Línea",
    },
    linePlaceholder: {
        en: "Line",
        es: "Línea",
    },
    serial: {
        en: "Serial",
        es: "Serial",
    },
    serialPlaceholder: {
        en: "Serial",
        es: "Serial",
    },
    carrier: {
        en: "Carrier",
        es: "Proveedor",
    },
    carrierPlaceholder: {
        en: "Carrier",
        es: "Proveedor",
    },
    addressPlaceholder: {
        en: "Address",
        es: "Dirección",
    },
    contactName: {
        en: "Contact Name",
        es: "Contacto",
    },
    contactNamePlaceholder: {
        en: "Contact Name",
        es: "Contacto",
    },
    accountName: {
        en: "Users Name",
        es: "Nombre para usuario",
    },
    accountNamePlaceholder: {
        en: "Users Name",
        es: "Nombre para usuario",
    },
    passwordNorify: {
        en: "Passwords must have at least 6 characters and contain at least one of each of the following: uppercase letters, lowercase letters, numbers, and symbols.",
        es: "Las contraseñas deben tener 6 caracteres como mínimo y contener al menos uno de cada uno de los siguientes elementos: mayúsculas, minúsculas, números y símbolos.",
    },
    ttl: {
        en: "Session",
        es: "Sesion",
    },
    created: {
        en: "Issued ",
        es: "Creada ",
    },
    sessions: {
        en: "Sessions",
        es: "Sesiones",
    },
    die: {
        en: "Expires ",
        es: "Expira ",
    },
    principal: {
        en: "Main",
        es: "Principal",
    },
    ckNewAccount: {
        en: "Create main user",
        es: "Crear usuario principal.",
    },
    selectAll: {
        en: "Show all",
        es: "Mostrar todos",
    },
    serviceProviderAccount: {
        en: "Service Provider Users",
        es: "Proveedor de Servicios",
    },
    timeZone: {
        en: " Time Zone",
        es: "Zona horaria",
    },
    timeZonePlaceholder: {
        en: " Time Zone",
        es: "Zona horaria",
    },
    group: {
        en: "Group",
        es: "Grupo",
    },
    showTrail: {
        en: "View trail",
        es: "Ver rastro",
    },
    modelSendType: {
        en: "Model send",
        es: "Protocolo de conexión",
    },
    maintenanceType: {
        en: "Type",
        es: "Tipo",
    },
    exceeded: {
        en: "Exceeded",
        es: "Excedidos",
    },
    toComplete: {
        en: "To complete",
        es: "Por completar",
    },
    lastResetDate: {
        en: "Last maintenance",
        es: "Último mantenimiento",
    },
    commentPlaceholder: {
        en: "Insert a comment",
        es: "Inserte un comentario",
    },
    brand: {
        en: "Brand",
        es: "Marca",
    },
    modelProfile: {
        en: "Profiles",
        es: "Perfiles",
    },
    deviceModelDefaultTrue: {
        en: "You can't change the model if it's a default profile.",
        es: "No puedes cambiar el Modelo del perfil principal.",
    },
    selectOption: {
        en: "Select an option",
        es: "Seleccione una opción",
    },
    lastMaintenanceDate: {
        en: "Date",
        es: "Fecha",
    },
    progress: {
        en: "Progress",
        es: "Progreso",
    },
    accumulated: {
        en: "Accumulated",
        es: "Acumulada",
    },
    remaining: {
        en: "Remaining",
        es: "Restante",
    },
    phone: {
        en: "Telephone",
        es: "Telefono",
    },
    phonePlaceholder: {
        en: "Insert telephone",
        es: "Ingrese un telefono",
    },
    cellPhone: {
        en: "Cell Phone",
        es: "Celular",
    },
    activateService: {
        en: "Activate Service?",
        es: "Activar Servicio?",
    },
    deactivateService: {
        en: "Deactivate Service?",
        es: "Desactivar Servicio?",
    },
    activate: {
        en: "Activate",
        es: "Activar",
    },
    deactivate: {
        en: "Deactivate",
        es: "Desactivar",
    },
    host: {
        en: "Host",
        es: "Host",
    },
    port: {
        en: "Port",
        es: "Puerto",
    },
    ssl: {
        en: "SSL",
        es: "SSL",
    },
    generate: {
        en: "Generate",
        es: "Generar",
    },
    course: {
        en: "Course",
        es: "Curso",
    },
    file: {
        en: "File",
        es: "Archivo",
    },
    selectFile: {
        en: "Select file",
        es: "Seleccionar archivo",
    },
    uploadFileButton: {
        en: "Upload",
        es: "Subir",
    },
    uploadSuccess: {
        en: "Upload success",
        es: "Carga exitosa",
    },
    uploadSuccessMessage: {
        en: "The file was uploaded successfully",
        es: "El archivo fue subido exitosamente",
    },
    hasHeaders: {
        en: "Has headers",
        es: "Tiene encabezados",
    },
    uploadSelect: {
        en: "Select",
        es: "Seleccionar",
    },
    uploadResult: {
        en: "Result",
        es: "Resultado",
    },
    template: {
        en: "Template",
        es: "Plantilla",
    },
    replaceDuplicates: {
        en: "Replace duplicates",
        es: "Reemplazar duplicados",
    },
    advanceConfiguration: {
        en: "Advance configuration",
        es: "Configuración avanzada",
    },
    loadMaps: {
        en: "Load Maps",
        es: "Cargar Mapas",
    },
    deleteSuccess: {
        en: "All models were deleted.",
        es: "Se eliminaron los modelos asignados.",
    },
    allTrace: {
        en: "All",
        es: "Todo",
    },
    lastTrace: {
        en: "Last",
        es: "Ultimo",
    },
    noneTrace: {
        en: "None",
        es: "Nada",
    },
    expiredDate: {
        en: "Expiration date",
        es: "Fecha de expiración",
    },
    shareDevicesEmailsPlaceholder: {
        en: "Insert emails",
        es: "Ingrese correos",
    },
    shareDevicesPhonesPlaceholder: {
        en: "Insert phone number",
        es: "Ingrese numeros de telefono",
    },
    shareDevices: {
        en: "Share devices",
        es: "Compartir unidades",
    },
    shared: {
        en: "Shared",
        es: "Compartido",
    },
    unitsToShare: {
        en: "Units to share",
        es: "Unidades a compartir",
    },
    sms: {
        en: "Text message",
        es: "Mensaje de texto",
    },
    message: {
        en: "Message",
        es: "Mensaje",
    },
    smsForLink: {
        en: "SMS",
        es: "SMS",
    },
    pois: {
        en: "Points of Interests",
        es: "Puntos de Interes",
    },
    exit: {
        en: "Exit",
        es: "Salir",
    },
    searchAddressPlaceholder: {
        en: "Search address.",
        es: "Buscar dirección.",
    },
    identity: {
        en: "Identity",
        es: "Identidad",
    },
    birthDate: {
        en: "Birth date",
        es: "Fecha de nacimiento",
    },
    expLicense: {
        en: "Driver's License Expiration Date",
        es: "Fecha de vencimiento de la licencia de conducir",
    },
    numberPlate: {
        en: "Plate",
        es: "Placa",
    },
    color: {
        en: "Color",
        es: "Color",
    },
    model: {
        en: "Model",
        es: "Modelo",
    },
    information: {
        en: "Information",
        es: "Información",
    },
    deviceInfo: {
        en: "Device",
        es: "Dispositivo",
    },
    driverInfo: {
        en: "Driver",
        es: "Conductor",
    },
    staffInfo: {
        en: "Staff",
        es: "Personal",
    },
    extraInfo: {
        en: "Extra",
        es: "Extra",
    },
    value: {
        en: "Value",
        es: "Valor",
    },
    command: {
        en: "Command",
        es: "Comando",
    },
    history: {
        en: "History",
        es: "Historial",
    },
    realTime: {
        en: "Real time",
        es: "Tiempo real",
    },
    type: {
        en: "Type",
        es: "Tipo",
    },
    countryPlaceholder: {
        en: "Select a country",
        es: "Seleccione un pais",
    },
    domain: {
        en: "Domain",
        es: "Dominio",
    },
    visible: {
        en: "Visible",
        es: "Visible",
    },
    showName: {
        en: "Name",
        es: "Nombre",
    },
    showImage: {
        en: "Image",
        es: "Imagen",
    },
    linkText: {
        en: "Hyperlink text",
        es: "Texto del enlace",
    },
    linkAddress: {
        en: "URL",
        es: "URL",
    },
    alertConfig: {
        en: "Alert config",
        es: "Configuración de alertas",
    },
    maintenanceDetail: {
        en: "Detail",
        es: "Detalle",
    },
    sid: {
        en: "Account SID",
        es: "SID de cuenta",
    },
    token: {
        en: "Auth Token",
        es: "Token de Autenticacion",
    },
    activeService: {
        en: "Activate Service",
        es: "Activar servicio",
    },
    messageSID: {
        en: "Messaging Service SID",
        es: "SID de servicio de mensajeria",
    },
    TwilioMessageService: {
        en: "Messaging Service",
        es: "Servicio de mensajeria",
    },
    messageDisclamer: {
        en: "If you deactivate the messaging service you will need to provide a phone number.",
        es: "Si desactiva el servicio de mensajeria necesitara proveer un numero de telefono.",
    },
    apikey: {
        en: "API Key",
        es: "API Key",
    },
    sslTitle: {
        en: "Secure mail service",
        es: "Servicio de correo seguro",
    },
    fuelTankConfig: {
        en: "Fuel tank configuration",
        es: "Configuración del tanque de combustible",
    },
    cameraConfig: {
        en: "Camera configuration",
        es: "Configuración de cámara",
    },
    analogInput: {
        en: "Analog input",
        es: "Entrada análoga",
    },
    sensors: {
        en: "Sensors",
        es: "Sensores",
    },
    sensor: {
        en: "Sensor",
        es: "Sensor",
    },
    width: {
        en: "Width",
        es: "Ancho",
    },
    height: {
        en: "Height",
        es: "Alto",
    },
    length: {
        en: "Length",
        es: "Largo",
    },
    minVolume: {
        en: "Minimun volume",
        es: "Volumen minimo",
    },
    diameter: {
        en: "Diameter",
        es: "Diametro",
    },
    inputVoltage: {
        en: "Input voltage",
        es: "Voltaje de entrada",
    },
    excelFormula: {
        en: "Excel formula",
        es: "Fórmula de Excel",
    },
    formulaInLiters: {
        en: "Formula in liters",
        es: "Fórmula en litros",
    },
    volume: {
        en: "Volume",
        es: "Volumen",
    },
    example: {
        en: "Example",
        es: "Ejemplo",
    },
    formula: {
        en: "Formula",
        es: "Fórmula",
    },
    custom: {
        en: "Custom",
        es: "Personalizada",
    },
    privateProfile: {
        en: "Private profile",
        es: "Perfil privado",
    },
    publicProfile: {
        en: "Public profile",
        es: "Perfil público",
    },
    selectEvents: {
        en: "Select events",
        es: "Seleccione eventos",
    },
    selectCommands: {
        en: "Select commands",
        es: "Seleccione comandos",
    },
    profileInfo: {
        en: "Profile Info",
        es: "Info. del perfil",
    },
    commands: {
        en: "Commands",
        es: "Comandos",
    },
    resetType: {
        en: "Reset type",
        es: "Tipo de restablecimiento",
    },
    accumulatedDistance: {
        en: "Accumulated",
        es: "Acumulado",
    },
    accumulatedPlaceholder: {
        en: "Insert accumulated",
        es: "Ingrese el acumulado",
    },
    serviceProviderDetail: {
        en: "Service Provider Details",
        es: "Detalle del proveedor de servicios",
    },
    userDetail: {
        en: "User Details",
        es: "Detalle del usuario",
    },
    dateType: {
        en: "On specific date",
        es: "En una fecha específica",
    },
    accumulatedType: {
        en: "By distance driven since last mainantence",
        es: "Por distancia conducida desde el último mantenimiento",
    },
    accumulatedHourType: {
        en: "By hour since last mainantence",
        es: "Por hora desde el último mantenimiento",
    },
    tankResume: {
        en: "Tanks Resume",
        es: "Resumen de Tanques",
    },
    geocodingTitle: {
        en: "Geocoding",
        es: "Geocodificación",
    },
    geocodingMethod: {
        en: "Method",
        es: "Método",
    },
    geocodingFormat: {
        en: "Format",
        es: "Formato",
    },
    geocodingMethodDisable: {
        en: "Disabled",
        es: "Desactivado",
    },
    geocodingMethodGoogle: {
        en: "Google",
        es: "Google",
    },
    geocodingMethodHere: {
        en: "Here",
        es: "Here",
    },
    geocodingFormatUS: {
        en: "US",
        es: "US",
    },
    geocodingFormatHN: {
        en: "Hn",
        es: "HN",
    },
    maxVolume: {
        en: "Max volume",
        es: "Volumen maximo",
    },
    editableGroup: {
        en: "Let users edit the group.",
        es: "Permitir a los usuarios editar el grupo.",
    },
    sendVerificationEmail: {
        en: "Send verification email",
        es: "Enviar correo de verificación",
    },
    fullDay: {
        en: "Full day",
        es: "Todo el dia",
    },
    morning: {
        en: "Morning",
        es: "Mañana",
    },
    afternoon: {
        en: "Afternoon",
        es: "Tarde",
    },
    updateInformation: {
        en: "Update information",
        es: "Actualizar información",
    },
    rastreoDescription: {
        en: "Rastreo description",
        es: "Descripción Rastreo",
    },
    optimusDescription: {
        en: "Optimus description",
        es: "Descripción Optimus",
    },
    totalConsumption: {
        en: "Total Consumption",
        es: "Consumo Total",
    },
    irregularConsumption: {
        en: "Irregular Consumption",
        es: "Consumo Irregular",
    },
    syncDevices: {
        en: "Units Sync",
        es: "Sincronizar Unidades",
    },
    fuelVolume: {
        en: "Fuel volume",
        es: "Volumen de combustible",
    },
    fuelValue: {
        en: "Fuel value",
        es: "Valor del combustible",
    },
    fuelBillDate: {
        en: "Invoice date",
        es: "Fecha de la factura",
    },
    odometer: {
        en: "Odometer",
        es: "Odómetro",
    },
    import: {
        en: "Import",
        es: "Importar",
    },
    radius: {
        en: "Radius",
        es: "Radio",
    },
    availableRange: {
        en: "The available range is between {value1} and {value2} {metric}.",
        es: "El rango disponible es entre {value1} y {value2} {metric}.",
    },
    clientAdminDetails: {
        en: "Client admin details",
        es: "Detalle cliente administrador",
    },
    userDetails: {
        en: "User details",
        es: "Detalles de usuario",
    },
    userId: {
        en: "User ID",
        es: "ID de Usuario",
    },
    generatePassword: {
        en: "Generate Password",
        es: "Generar Contraseña",
    },
    selectCommandType: {
        en: "Select a command type",
        es: "Seleccione un tipo de comando",
    },
    basicUsage: {
        en: "Basic Usage",
        es: "Uso básico",
    },
    entry: {
        en: "Entry",
        es: "Entrada",
    },
    missingReading: {
        en: "Missing reading",
        es: "Lectura faltante",
    },
    missingVolume: {
        en: "Missing volume",
        es: "Volumen faltante",
    },
    selectDriver: {
        en: "Select a driver",
        es: "Selecciona un conductor",
    },
    cellPhonePlaceholder: {
        en: "Cell Phone",
        es: "Celular",
    },
    uploadPhotoSucceful: {
        en: "The photo uploaded successfully",
        es: "La foto se cargo correctamente",
    },
    deviceRequirements: {
        en: "Required unit information",
        es: "Información requerida de la unidad",
    },
    availableDevices: {
        en: "Available units",
        es: "Unidades disponibles",
    },
    requirementsMissing: {
        en: "Requirements not met",
        es: "No cumplen los requisitos",
    },
    clientCredits: {
        en: "Credits",
        es: "Créditos",
    },
    maxClientCredits: {
        en: "Max credits",
        es: "Créditos máximos",
    },
    keyId: {
        en: "Key id",
        es: "Identificador de llave",
    },
    Key: {
        en: "Key",
        es: "Llave",
    },
    smsLimit: {
        en: "SMS limit",
        es: "Límite de SMS",
    },
    emailLimit: {
        en: "Email limit",
        es: "Límite de correo",
    },
    clientComments: {
        en: "Client Comments",
        es: "Comentarios sobre el cliente",
    },
    otherUsers: {
        en: "Other Users",
        es: "Otros Usuarios",
    },
    observations: {
        en: "Observations",
        es: "Observaciones",
    },
    off: {
        en: "Off",
        es: "Apagado",
    },
    car: {
        en: "Car",
        es: "Carro",
    },
    truck: {
        en: "Truck",
        es: "Camión",
    },
    poisAbbreviation: {
        en: "POI",
        es: "PDI",
    },
    mapSettings: {
        en: "Map settings",
        es: "Ajustes de mapa",
    },
    manually: {
        en: "Manually",
        es: "Manual",
    },
    channel: {
        en: "Channel",
        es: "Canal",
    },
    dashCam: {
        en: "Dash Cam",
        es: "Dash Cam",
    },
};
exports.default = translations;
